// base
import * as React from 'react';
import * as moment from 'moment';
// import { Typography } from '@material-ui/core';
// model
import { KansatsuKirokuSubdiv } from '../../models/KansatsuKirokuSubdiv';
import { SiteInfo } from '../../models/SiteInfo';

import { InferenceResultSubdiv } from '../../models/InferenceResultSubdiv';
import { InferenceAdditionalResultSubdiv } from '../../models/InferenceAdditionalResultSubdiv';

// parts
import { InferenceResultSubdivView } from '../parts/InferenceResultSubdivView';
import KansatsuKirokuEdit from '../parts/KansatsuKirokuEdit';
import KansatsuKirokuScoreEditForSubdiv from '../parts/KansatsuKirokuScoreEditForSubdiv'; // 総合評価表の表示 観察記録のスコア入力エリア

const ROCK_MASS_GROUPS = [
  { id: 'MASSIVE_HARD_ROCK', name: '【塊状】硬質岩' },
  { id: 'MASSIVE_MEDIUM_SOFT_ROCK', name: '【塊状】中硬質岩・軟硬質岩' },
  { id: 'LAYERED_MEDIUM_ROCK', name: '【層状】中硬質岩' },
  { id: 'LAYERED_SOFT_ROCK', name: '【層状】軟硬質岩' },
];

interface OwnProps {
  siteInfo: SiteInfo;
  kansatsuKiroku: KansatsuKirokuSubdiv;
  KansatsuKirokuObsrecScore: { // 人判断の観察項目情報 「KansatsuKirokuObsrec['observationsScores']」と同じ型 印刷のために利用
    observationsScores: Array<{
      observation: string; // 観察項目
      scores: Array<{
        position: string; // 位置（左上から右方向でカウントしたときの位置）
        score: string; // スコア
      }>;
    }>,
    resultHuman: InferenceResultSubdiv[]; // 人判断のresult(人判断の総合評価用)
    additionalResultHuman: InferenceAdditionalResultSubdiv; // 人判断のadditionalResult(人判断の総合評価用)
    selectedRockMassGroup?: string;
    excavationFaceScoreConversionTableData?: SiteInfo['excavationFaceScoreConversionTableData'];
    observationMap?: SiteInfo['observationMap'];
    isIncludeInSubtotalObservations?: SiteInfo['isIncludeInSubtotalObservations'];
    isIncludeInTotalObservations?: SiteInfo['isIncludeInTotalObservations'];
  }
};
/**
 * 観察記録印刷用コンポーネント
 */

interface OwnState {
}

class PrintKansatsuKirokuSubdiv extends React.Component<OwnProps, OwnState> {

  /**
   * 観察項目キー、岩石グループ、元のスコアから変換後のスコアを取得する
   */
  getConvertedScore(observationKey: string, rockGroup: string, originalScoreStr: string): number {
    const originalScore = parseInt(originalScoreStr, 10);
    if (isNaN(originalScore) || originalScore < 0 || originalScore > 6) {
      return -1; // 不正なスコア
    }

    const conversionTable = this.props.KansatsuKirokuObsrecScore.excavationFaceScoreConversionTableData;
    if (!conversionTable || !observationKey || !rockGroup) {
      return -1; // 変換テーブルやキーがない, または岩石グループが未選択
    }

    const entry = conversionTable.find(
      (item) => item.observation === observationKey && item.rock_group === rockGroup
    );

    if (!entry) {
      return -1; // 対応する変換ルールがない
    }

    const gradeKey = `eval_grade_${originalScore}` as keyof typeof entry;
    const convertedScore = entry[gradeKey];

    if (typeof convertedScore !== 'number') {
        return -1;
    }

    return convertedScore;
  }

  /**
   * 左肩、天端、右肩のスコアから加重平均を計算する
   */
  calculateWeightedAverage(left: number, top: number, right: number): number {
    if (left === -1 || top === -1 || right === -1) {
      return NaN;
    }
    const weightedSum = left + top * 2 + right;
    const average = weightedSum / 4;
    return Math.round(average * 10) / 10;
  }

  /**
   * 指定されたキーの観察項目スコアを集計する
   */
  calculateTotals(
      excavationFaceScores: Array<{ observationKey: string; left: number; top: number; right: number; }>,
      keysToInclude?: string[]
    ) {
      let totalLeft = 0;
      let totalTop = 0;
      let totalRight = 0;

      excavationFaceScores.forEach(score => {
        if (!keysToInclude || keysToInclude.includes(score.observationKey)) {
          if (score.left !== -1) {
            totalLeft += score.left;
          }
          if (score.top !== -1) {
            totalTop += score.top;
          }
          if (score.right !== -1) {
            totalRight += score.right;
          }
        }
      });
      const totalAverage = this.calculateWeightedAverage(totalLeft, totalTop, totalRight);

      return {
        left: totalLeft,
        top: totalTop,
        right: totalRight,
        average: isNaN(totalAverage) ? ' ' : totalAverage.toFixed(1),
      };
  };

  render() {
    const excavationFaceScores: Array<{
      observationKey: string;
      observationName: string;
      left: number;
      top: number;
      right: number;
      average: number | string;
    }> = [];

    const observationMap = this.props.KansatsuKirokuObsrecScore.observationMap || {};
    const reverseObservationMap: { [key: string]: string } = {};
    for (const key in observationMap) {
      if (Object.prototype.hasOwnProperty.call(observationMap, key)) {
        reverseObservationMap[observationMap[key]] = key;
      }
    }

    const selectedRockMassGroup = this.props.KansatsuKirokuObsrecScore.selectedRockMassGroup;

    if (this.props.KansatsuKirokuObsrecScore.resultHuman && this.props.KansatsuKirokuObsrecScore.excavationFaceScoreConversionTableData && selectedRockMassGroup) {
        this.props.KansatsuKirokuObsrecScore.resultHuman.forEach(item => {
        const observationName = item.observation_name;
        const observationKey = reverseObservationMap[observationName];

        if (observationKey && item.result_score) {
          const leftScoreStr = (item.result_score.left && item.result_score.left.mode) ? item.result_score.left.mode : '-1';
          const topScoreStr = (item.result_score.top && item.result_score.top.mode) ? item.result_score.top.mode : '-1';
          const rightScoreStr = (item.result_score.right && item.result_score.right.mode) ? item.result_score.right.mode : '-1';

          const convertedLeft = this.getConvertedScore(observationKey, selectedRockMassGroup, leftScoreStr);
          const convertedTop = this.getConvertedScore(observationKey, selectedRockMassGroup, topScoreStr);
          const convertedRight = this.getConvertedScore(observationKey, selectedRockMassGroup, rightScoreStr);
          const weightedAverage = this.calculateWeightedAverage(convertedLeft, convertedTop, convertedRight);

          excavationFaceScores.push({
            observationKey,
            observationName,
            left: convertedLeft,
            top: convertedTop,
            right: convertedRight,
            average: isNaN(weightedAverage) ? '-' : weightedAverage.toFixed(1),
          });
        }
      });
    }

    const subtotalKeys = this.props.KansatsuKirokuObsrecScore.isIncludeInSubtotalObservations || [];
    const totalKeys = this.props.KansatsuKirokuObsrecScore.isIncludeInTotalObservations || [];

    const subTotals = subtotalKeys.length > 0 ? this.calculateTotals(excavationFaceScores, subtotalKeys) : null;
    const totals = totalKeys.length > 0 ? this.calculateTotals(excavationFaceScores, totalKeys) : null;

    const foundGroup = ROCK_MASS_GROUPS.find(g => g.id === selectedRockMassGroup);
    const selectedGroupName = foundGroup ? foundGroup.name : '未選択';


    return (
      <div>
        {/* 1Page目 */}
        <div style={{ margin: '50px' }}>
          {/* ヘッダ部分 */}
          <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', fontSize: '120%' }}>
              {this.props.siteInfo.koujiBangou} : {this.props.siteInfo.name}
            </div>
            <div style={{ display: 'flex', fontSize: '80%' }}>
              作成 {this.props.kansatsuKiroku.createdAt ? moment(this.props.kansatsuKiroku.createdAt).format('MM/DD HH:mm') : '-'}<br />
              更新 {this.props.kansatsuKiroku.lastModifiedAt ? moment(this.props.kansatsuKiroku.lastModifiedAt).format('MM/DD HH:mm') : '-'}
            </div>
          </div>

          {/* 印刷本体(1page目) */}
          <div style={{ width: '100%', display: 'flex' }}>
            {/* 2カラム表示にする */}
            <div style={{ display: 'flex', flexDirection: 'column', minWidth: '50%' }}>
              {/* 観察記録情報Box */}
              <div style={{ display: 'flex', zoom: '50%' }}>
                <KansatsuKirokuEdit
                  disabled={false}  // 編集不可にするとテキストがグレー表示で見づらいので編集可能でボタンを非表示とする
                  hideButtons={true}
                  data={this.props.kansatsuKiroku}
                />
              </div>
              {/* 観察記録情報Boxここまで */}
              {/* 診断画像Box */}
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div style={{ marginBottom: '10px' }}>診断画像</div>
                <div>
                  {
                    (this.props.kansatsuKiroku.croppedImageSignedUrl)
                      ? <img
                        style={{ maxHeight: '300px', maxWidth: '500px' }}
                        src={this.props.kansatsuKiroku.croppedImageSignedUrl} />
                      : <div>診断画像なし</div>
                  }
                </div>
              </div>
              {/* 診断画像Boxここまで */}
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', width: '50%', zoom: '70%'/* 印刷用に少し縮小 */ }}>
              {/* 診断結果Box */}
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div style={{ marginBottom: '10px', fontWeight: 'bold' }}>AI診断による総合評価</div>
                {
                  this.props.kansatsuKiroku.inferenceResultSubdiv
                    ? <InferenceResultSubdivView
                      hideImages={true}
                      result={this.props.kansatsuKiroku.inferenceResultSubdiv}
                      additionalResult={this.props.kansatsuKiroku.inferenceAdditionalResultSubdiv}
                    />
                    : <div>診断結果なし</div>
                }
                <hr style={{margin: '15px 0'}}/>
                {
                  this.props.KansatsuKirokuObsrecScore.resultHuman.length === 0 ? null : (
                    <div>
                      <div style={{ marginBottom: '10px', fontWeight: 'bold' }}>修正を加味した総合評価</div>
                      {
                        this.props.KansatsuKirokuObsrecScore.resultHuman
                          ? <InferenceResultSubdivView
                            hideImages={true}
                            result={this.props.KansatsuKirokuObsrecScore.resultHuman}
                            additionalResult={this.props.KansatsuKirokuObsrecScore.additionalResultHuman}
                          />
                          : <div>診断結果なし</div>
                      }
                    </div>
                  )
                }
              </div>
            </div>
          </div>
          {/* 印刷本体(2page目 相当 - breakBefore: page で改ページ) */}
          <div style={{ breakBefore: 'page', margin: '50px' }}>
            { this.props.KansatsuKirokuObsrecScore.resultHuman.length !== 0 && (
              <div style={{ zoom: '70%'/* 1ページ目右カラムのスタイルに合わせる */, marginBottom: '20px' }}> {/* テーブルと画像リストの間に少しマージンを追加 */}
                <div style={{ marginTop: '20px', marginBottom: '10px' }}>
                  <span style={{ fontWeight: 'bold' }}>岩石グループ選択: </span>
                  <span>{selectedGroupName}</span>
                </div>

                <div style={{ marginBottom: '10px', fontWeight: 'bold' }}>切羽評価点</div>
                <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '20px' }} className="inferenceresulttable">
                  <thead>
                    <tr>
                      <th>観察項目</th>
                      <th style={{ width: '70px' }}>左肩</th>
                      <th style={{ width: '70px' }}>天端</th>
                      <th style={{ width: '70px' }}>右肩</th>
                      <th style={{ width: '70px' }}>加重平均</th>
                    </tr>
                  </thead>
                  <tbody>
                    {excavationFaceScores.map((item, index) => (
                      <tr key={`efs_print_item_${index}`} className={(index % 2 === 0) ? 'even' : ''}>
                        <td>{`${item.observationKey}. ${observationMap[item.observationKey] || item.observationName}`}</td>
                        <td style={{ textAlign: 'center' }}>{item.left === -1 ? ' ' : item.left}</td>
                        <td style={{ textAlign: 'center' }}>{item.top === -1 ? ' ' : item.top}</td>
                        <td style={{ textAlign: 'center' }}>{item.right === -1 ? ' ' : item.right}</td>
                        <td style={{ textAlign: 'center' }}>{item.average}</td>
                      </tr>
                    ))}
                    {subTotals && (
                      <tr style={{ borderTop: 'solid 1px gray' }}>
                        <th style={{ textAlign: 'left' }}>{`${subtotalKeys.join(', ')} の合計`}</th>
                        <td style={{ textAlign: 'center' }}>{subTotals.left}</td>
                        <td style={{ textAlign: 'center' }}>{subTotals.top}</td>
                        <td style={{ textAlign: 'center' }}>{subTotals.right}</td>
                        <td style={{ textAlign: 'center' }}>{subTotals.average}</td>
                      </tr>
                    )}
                    {totals && (
                      <tr style={{ borderTop: 'solid 1px gray' }}>
                        <th style={{ textAlign: 'left' }}>{`${totalKeys.join(', ')} の合計`}</th>
                        <td style={{ textAlign: 'center' }}>{totals.left}</td>
                        <td style={{ textAlign: 'center' }}>{totals.top}</td>
                        <td style={{ textAlign: 'center' }}>{totals.right}</td>
                        <td style={{ textAlign: 'center' }}>{totals.average}</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}

            {/* スコア入力エリア */}
            <KansatsuKirokuScoreEditForSubdiv
              disabled={false}
              data={this.props.KansatsuKirokuObsrecScore.observationsScores}
              lineNum={this.props.siteInfo.lineNum}
              columnNum={this.props.siteInfo.columnNum}
              observationNames={this.props.siteInfo.observationNames}
              observationDescriptions={this.props.siteInfo.observationDescriptions}

              result={this.props.kansatsuKiroku.inferenceResultSubdiv}
              additionalResult={this.props.kansatsuKiroku.inferenceAdditionalResultSubdiv}
              cropImageWidth={this.props.siteInfo.cropImageWidth}
              orgdata={this.props.kansatsuKiroku.observationsScoresOrg}
              hideTable={true}
              isPrint={true}
              // 評価値確定ルール関連props
              targetStepRuleObservationNames={this.props.siteInfo.targetStepRuleObservationNames}
              targetModeRuleObservationNames={this.props.siteInfo.targetModeRuleObservationNames}
              targetMeanDeduplicationRuleObservationNames={this.props.siteInfo.targetMeanDeduplicationRuleObservationNames}
              targetMeanGeneralRuleObservationNames={this.props.siteInfo.targetMeanGeneralRuleObservationNames}
              topBadsideSize={this.props.siteInfo.topBadsideSize}
              leftBadsideSize={this.props.siteInfo.leftBadsideSize}
              rightBadsideSize={this.props.siteInfo.rightBadsideSize}
              excavationFaceScoreConversionTableData={this.props.KansatsuKirokuObsrecScore.excavationFaceScoreConversionTableData}
              observationMap={this.props.KansatsuKirokuObsrecScore.observationMap}
              isIncludeInSubtotalObservations={this.props.KansatsuKirokuObsrecScore.isIncludeInSubtotalObservations}
              isIncludeInTotalObservations={this.props.KansatsuKirokuObsrecScore.isIncludeInTotalObservations}

            />
          </div>
        </div>
      </div>
    );
  }
}

export { PrintKansatsuKirokuSubdiv };



// WEBPACK FOOTER //
// ./src/components/subdiv/PrintKansatsuKirokuSubdiv.tsx